import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <Link className="brand brand-dark" to="/">
          <span className="brand-mark">L</span><span>ligentway<span className="brand-dot">.</span></span>
        </Link>
        <p>AI that works for people,<br />not the other way around.</p>
        <div className="footer-links"><Link to="/about">About</Link><Link to="/faq">FAQ</Link><Link to="/contact">Contact</Link></div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} Ligentway OÜ</span><span>Based in Europe · Working everywhere</span></div>
    </footer>
  );
}

export default Footer;
